'use client';

import classNames from 'classnames';
import Link from 'next/link';
import React, { useState } from 'react';
import Marquee from 'react-fast-marquee';

type Props = {
  nextLink: string;
  hoverTextColor?: string;
};

export const CaseStudyNav = (props: Props) => {
  const { nextLink = '/', hoverTextColor = 'text-at' } = props;
  const [direction, setDirection] = useState<'left' | 'right'>('left');
  const [speed, setSpeed] = useState<50 | 80>(80);

  const handleMouseEnter = () => {
    setDirection('right');
    setSpeed(50);
  };
  const handleMouseLeave = () => {
    setDirection('left');
    setSpeed(80);
  };

  return (
    <div
      className={classNames(
        'relative z-20 w-full cursor-pointer bg-white py-12 text-[#2E3C4A] tablet:py-[96px]',
        `hover:${hoverTextColor}`,
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Marquee autoFill={true} speed={speed} pauseOnHover={false} direction={direction}>
        <Link href={nextLink} aria-label="Next case study">
          <h4 className="overflow-visible px-4 text-[clamp(18px,calc(18px+2.8125vw),63px)] font-kraftig">
            Next case study
          </h4>
        </Link>
      </Marquee>
    </div>
  );
};
